import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import installElementPlus from './plugins/element'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 初始化样式表
import '@/styles/index.scss'

// 导入路由鉴权
import './permission'

// 注册指令
import installDirective from '@/directives'
import store from './store'

const app = createApp(App)
app.config.globalProperties.$icons = []
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.config.globalProperties.$icons.push(key)
    app.component(key, component)
}
installElementPlus(app)
installDirective(app)
app.use(store).use(router).mount('#app')
